import { Col, Form, Input, Row } from 'antd';
import { Heading2 } from 'components/Heading2';
import { normalizeCpfCnpj, normalizePhone } from 'helpers/normalizers';
import { cpfCnpjRule, emailRule } from 'helpers/rules';
import { TextL, TextS } from 'components/Text';
import { IoMdArrowForward } from 'react-icons/io';
import { ForwardButton } from '../styles';
import { PayerType } from '../types';
import AddressContainer from 'components/Address/Address';
import { useState } from 'react';
import { Address } from 'types/Address';

interface IChargesNewPayerProps {
	payer?: PayerType;
	onNext: (payer: PayerType) => void;
}
const ChargesNewPayer = ({ payer, onNext }: IChargesNewPayerProps) => {
	const [address, setAddress] = useState<Address>({
		city: payer?.city,
		district: payer?.district,
		postal_code: payer?.postal_code,
		state_code: payer?.state,
		street_name: payer?.street,
		street_number: payer?.number,
	});

	return (
		<Row style={{ maxWidth: 1000 }}>
			<Col span={24}>
				<Row>
					<Col span={24}>
						<Heading2 style={{ margin: '30px 0px' }}>
							Dados do Pagador
						</Heading2>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Form<PayerType>
							style={{ width: '100%' }}
							initialValues={{
								name: payer?.name,
								taxpayer_id:
									payer?.taxpayer_id &&
									normalizeCpfCnpj(payer.taxpayer_id),
								phone:
									payer?.phone &&
									normalizePhone(payer?.phone),
								email_address: payer?.email_address,
							}}
							layout="vertical"
							onFinish={values =>
								onNext({
									...values,
									city: address?.city || '',
									district: address?.district || '',
									number: address?.street_number || '',
									postal_code: address?.postal_code || '',
									state: address?.state_code || '',
									street: address?.street_name || '',
								})
							}
						>
							<Row style={{ marginBottom: '16px' }}>
								<Col span={24}>
									<TextL>Dados básicos</TextL>
								</Col>
							</Row>
							<Row gutter={[16, 16]}>
								<Col span={17}>
									<Form.Item
										name="name"
										label="Nome completo ou razão social"
										rules={[
											{
												required: true,
												message: 'Campo obrigatório',
											},
										]}
									>
										<Input placeholder="Digite aqui" />
									</Form.Item>
								</Col>
								<Col span={7}>
									<Form.Item
										name="taxpayer_id"
										label="CPF / CNPJ"
										normalize={e => normalizeCpfCnpj(e)}
										rules={[
											{
												required: true,
												message: 'Campo obrigatório',
											},
											cpfCnpjRule,
										]}
									>
										<Input placeholder="000.000.000-00" />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[16, 16]}>
								<Col span={12}>
									<Form.Item
										name="phone"
										label="Telefone"
										normalize={e => normalizePhone(e)}
										rules={[
											{
												required: true,
												message: 'Campo obrigatório',
											},
										]}
									>
										<Input placeholder="(00) 0 0000-0000" />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										name="email_address"
										label="E-mail"
										rules={[emailRule('email_address')]}
									>
										<Input placeholder="Digite aqui" />
									</Form.Item>
								</Col>
							</Row>
							<AddressContainer
								setAddress={setAddress}
								address={address}
							/>
							<Row
								gutter={[16, 16]}
								style={{ margin: '3rem 0 1rem' }}
								justify="end"
							>
								<Col>
									<ForwardButton
										type="primary"
										htmlType="submit"
									>
										<TextS>Avançar</TextS>
										<IoMdArrowForward size={16} />
									</ForwardButton>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export default ChargesNewPayer;
